import {
  Box,
  Card,
  Divider,
  Grid,
  IconButton,
  Typography,
  Skeleton,
  useTheme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import WarningIcon from "@mui/icons-material/Warning";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import { ButtonBasic, CardOTZTask, TextInfoTicket } from "../../components";
import ZTaskService from "../../services/ztask.service";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useState, useEffect, useContext } from "react";
import TabCuentaTicket from "./tabs/TabCuentaTicket";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { showModal } from "react-redux-modal-provider";
import ContactosAction from "../../store/actions/contactos";
import ContactosService from "../../services/contactos.service";
import InfContactoService from "../../services/infContacto.service";
import TabCuentaConsultas from "./tabs/TabCuentaConsultas";
import ConsultasService from "../../services/consultas.service";
import LogService from "../../services/log.service";
import TabCuentaHistorico from "./tabs/TabCuentaHistorico";
import FileAdjContactoService from "../../services/fileAdjContacto.service";
import TabCuentaDocumentacion from "./tabs/TabCuentaDocumentacion";
import TabCuentaPreServicio from "./tabs/TabCuentaPreServicio";
import TabCuentaServicio from "./tabs/TabCuentaServicio";
import TabCuentaEditar from "./tabs/TabCuentaEditar";
import TabCuentaTareas from "./tabs/TabCuentaTareas";
import CalendarioV2Service from "../../services/calendarioV2.service";
import RecordatorioService from "../../services/recordatorio.service";
import { SocketContext } from "../../context/SocketContext";
import TabCuentaRecodatorios from "./tabs/TabCuentaRecodatorios";
import usePermisos from "../../hooks/usePermisos";
import ModalSaldoPendiente from "../../modals/servicio/ModalSaldoPendiente";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ maxHeight: "79vh", overflow: "auto" }}
      className="side"
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// Componente Skeleton para el panel de cuenta
const CuentaSkeleton = ({ isDarkMode }) => (
  <Card
    sx={{
      background: isDarkMode ? "#2d3a52 !important" : "#fff !important",
      p: 2,
      borderRadius: 4,
      boxShadow: isDarkMode
        ? "0px -3px 0px 0px #90caf9"
        : "0px -3px 0px 0px #0364ff",
    }}
  >
    <Skeleton
      variant="circular"
      width={40}
      height={40}
      sx={{ mb: 2, bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0" }}
    />

    {/* Avatar y nombre */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        mb: 3,
      }}
    >
      <Skeleton
        variant="circular"
        width={50}
        height={50}
        sx={{ mb: 2, bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0" }}
      />
      <Skeleton
        variant="text"
        width="80%"
        height={40}
        sx={{ mb: 2, bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0" }}
      />
    </Box>

    {/* Información básica */}
    <Box sx={{ mb: 3 }}>
      {[1, 2, 3].map((item) => (
        <Box key={item} sx={{ mb: 1.5 }}>
          <Skeleton
            variant="text"
            width="40%"
            height={20}
            sx={{ bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0" }}
          />
          <Skeleton
            variant="text"
            width="60%"
            height={24}
            sx={{ bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0" }}
          />
        </Box>
      ))}
    </Box>

    {/* Blacklist opcional */}
    <Skeleton
      variant="text"
      width="70%"
      height={20}
      sx={{ mb: 1, bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0" }}
    />

    <Divider sx={{ mb: 2 }} />

    {/* Datos personales */}
    <Skeleton
      variant="text"
      width="60%"
      height={32}
      sx={{ mb: 2, bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0" }}
    />
    {[1, 2, 3, 4, 5, 6].map((item) => (
      <Box key={item} sx={{ mb: 1.5 }}>
        <Skeleton
          variant="text"
          width="30%"
          height={20}
          sx={{ bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0" }}
        />
        <Skeleton
          variant="text"
          width="70%"
          height={24}
          sx={{ bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0" }}
        />
      </Box>
    ))}
  </Card>
);

// Componente Skeleton para las tabs de cuenta
const CuentaTabsSkeleton = ({ isDarkMode }) => (
  <Card
    sx={{
      background: isDarkMode ? "#2d3a52 !important" : "#fff !important",
      p: 2,
      borderRadius: 4,
    }}
  >
    {/* Skeleton para las tabs */}
    <Box
      sx={{
        borderBottom: 1,
        borderColor: isDarkMode ? "#3d4a62" : "divider",
        mb: 3,
      }}
    >
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((tab) => (
          <Skeleton
            key={tab}
            variant="rectangular"
            width={80}
            height={32}
            sx={{
              borderRadius: 1,
              bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0",
            }}
          />
        ))}
      </Box>
    </Box>

    {/* Contenido de las tabs */}
    <Box sx={{ p: 3 }}>
      {/* Simulación de tabla o contenido */}
      <Box sx={{ mb: 3 }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={60}
          sx={{
            borderRadius: 1,
            mb: 2,
            bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0",
          }}
        />
        {[1, 2, 3, 4, 5].map((row) => (
          <Skeleton
            key={row}
            variant="rectangular"
            width="100%"
            height={40}
            sx={{
              borderRadius: 1,
              mb: 1,
              bgcolor: isDarkMode ? "#3d4a62" : "#e2e8f0",
            }}
          />
        ))}
      </Box>
    </Box>
  </Card>
);

const CuentaFindByIdScreen = ({ iniciarContacto }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const permisos = usePermisos();
  const { id } = useParams();
  const { sockets } = useContext(SocketContext);
  const [isLoading, setIsLoading] = useState(true);
  const [contacto, setContacto] = useState();
  const [contactoImg, setContactoImg] = useState(null);
  const [consultas, setConsultas] = useState([]);

  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [value, setValue] = useState(0);
  const [logs, setLogs] = useState([]);
  const [tareas, setTareas] = useState([]);
  const [filesAdj, setFilesAdj] = useState([]);
  const [recordatorios, setRecordatorios] = useState([]);
  const [otsServicio, setOtsServicio] = useState([]);

  const traerInfoContServicio = async () => {
    await InfContactoService.getAll({ cuentaId: id }).then((respp) => {
      setContactoImg(respp);
    });
  };
  const actualizar = async () => {
    setIsLoading(true);
    await ContactosService.getByIdCuenta(id, { type: "multi" })
      .then((response) => {
        setContacto(response);
        iniciarContacto(response);
        traerInfoContServicio();
      })
      .catch((e) => {
        console.log(e)
        if (e?.msg) {
          navigate("/");
        }else if(e?.redirect){
          navigate('/');
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const actualizarHistorico = async () => {
    await LogService.getAllContacto({ cuentaId: id }).then((resp) => {
      setLogs(resp);
    });
  };
  const actualizarConsultas = async () => {
    await ConsultasService.getAll({ cuenta: id, webV2: true }).then((resp) => {
      setConsultas(resp);
    });
  };
  const actualizarFileAdjContacto = async () => {
    await FileAdjContactoService.getAll({ cuentaId: id }).then((resp) => {
      setFilesAdj(resp);
    });
  };
  const actualizarTareas = async () => {
    await CalendarioV2Service.tareasCalendar({ cuentaId: id }).then((resp) => {
      setTareas(resp);
    });
  };
  const actualizarRecordatorios = async () => {
    await RecordatorioService.getAll({ cuentaId: id }).then((resp) => {
      setRecordatorios(resp);
    });
  };
  const actualizarOTs = async () => {
    await ZTaskService.getOTServicio({ cuentaId: id, all: true })
      .then((resp) => {
        setOtsServicio(resp?.ots || resp?.data?.ots || []);
      })
      .catch(() => {
        setOtsServicio([]);
      });
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const onGuardar = () => {
    actualizar();
    actualizarHistorico();
    actualizarConsultas();
    actualizarFileAdjContacto();
    actualizarTareas();
    actualizarRecordatorios();
    actualizarOTs();
  };
  const onConsultarSaldo = () => {
    const obtenerServiciosExtencion = contacto?.servicios?.filter(
      (servicio) =>
        Array.isArray(servicio?.extensiones) &&
        servicio?.extensiones.length > 0,
    );
    const contratosNros = obtenerServiciosExtencion?.map(
      (servicio) => servicio?.contrato,
    );
    console.log(contratosNros);
    showModal(ModalSaldoPendiente, {
      servicios: contratosNros,
    });
  };
  useEffect(() => {
    const room = `cuenta-${id}`;
    sockets?.emit("joinTicketRoom", room);
    actualizar();
    actualizarHistorico();
    actualizarConsultas();
    actualizarFileAdjContacto();
    actualizarTareas();
    actualizarRecordatorios();
    actualizarOTs();
    document.title = `Cuenta #${id}`;

    const onCuentaRefresh = () => {
      actualizar();
      actualizarHistorico();
      actualizarConsultas();
      actualizarFileAdjContacto();
      actualizarTareas();
      actualizarRecordatorios();
      actualizarOTs();
    };
    sockets?.on("cuentaRefresh", onCuentaRefresh);

    return () => {
      sockets?.off("cuentaRefresh", onCuentaRefresh);
      sockets?.emit("leaveTicketRoom", room);
    };
  }, [id]);
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflow: "auto",
        background: isDarkMode ? "#1a2332" : "#f5f5f5",
      }}
      className="side"
    >
      <Grid container p={3} mb={2} spacing={1}>
        <Grid item xs={12} md={3}>
          {isLoading ? (
            <CuentaSkeleton isDarkMode={isDarkMode} />
          ) : (
            <Card
              sx={{
                background: isDarkMode
                  ? "#2d3a52 !important"
                  : "#fff !important",
                p: 2,
                borderRadius: 4,
                boxShadow: isDarkMode
                  ? "0px -3px 0px 0px #90caf9"
                  : "0px -3px 0px 0px #0364ff",
              }}
            >
              <IconButton sx={{ boxShadow: 3 }} onClick={() => navigate(-1)}>
                <ArrowBackIcon
                  sx={{ color: isDarkMode ? "#90caf9" : "#000" }}
                />
              </IconButton>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    background: isDarkMode ? "#1F2A40" : "#e6f0ff",
                    borderRadius: 50,
                    width: 50,
                    height: 50,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AccountCircleIcon
                    sx={{
                      color: isDarkMode ? "#90caf9" : "#0364ff",
                      fontSize: 40,
                    }}
                  />
                </Box>
                <Typography
                  sx={{
                    color: isDarkMode ? "#90caf9" : "#0364ff",
                    fontWeight: "bold",
                    textAlign: "center",
                    mb: 2,
                  }}
                  variant="h4"
                >
                  {contacto?.nombre_completo}
                </Typography>
                <TextInfoTicket
                  titulo="Cliente ID"
                  descripcion={contacto?.cuenta || "-"}
                />
                <TextInfoTicket
                  titulo="Total Ticket"
                  descripcion={
                    contacto?.ticketsGral?.length ||
                    contacto?.tickets?.length ||
                    "0"
                  }
                />
                <TextInfoTicket
                  titulo="Categoria"
                  descripcion={
                    contacto?.categoria?.descripcion ||
                    contacto?.segmento ||
                    "-"
                  }
                />
              </Box>
              {contacto?.blacklist === "1" && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 0.75,
                    mt: 1.5,
                    mb: 1,
                    px: 1.5,
                    py: 0.75,
                    background:
                      "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
                    border: "2px solid #ef4444",
                    borderRadius: 1.5,
                    boxShadow: "0 2px 6px rgba(239, 68, 68, 0.15)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 3px 10px rgba(239, 68, 68, 0.25)",
                      transform: "scale(1.01)",
                    },
                  }}
                >
                  <WarningIcon
                    sx={{
                      color: "#dc2626",
                      fontSize: "1rem",
                    }}
                  />
                  <Typography
                    sx={{
                      color: "#dc2626",
                      fontWeight: 700,
                      fontSize: "0.75rem",
                      lineHeight: 1.3,
                      textAlign: "center",
                    }}
                  >
                    Cliente no apto para la venta
                  </Typography>
                </Box>
              )}
              <Divider
                sx={{
                  background: isDarkMode
                    ? "#3d4a62 !important"
                    : "#8993a4 !important",
                  marginBottom: 1,
                  width: "100%",
                }}
              />
              <Typography
                sx={{
                  color: isDarkMode ? "#e0e0e0" : "#000",
                  fontWeight: "bold",
                  mb: 2,
                }}
                variant="h5"
              >
                Datos personales
              </Typography>
              <TextInfoTicket
                titulo="DNI/CUIT"
                descripcion={contacto?.dni_cuit?.numero || contacto?.dni || "-"}
              />
              <TextInfoTicket
                titulo="Email"
                descripcion={
                  contacto?.contacto?.email || contacto?.email || "-"
                }
              />
              <TextInfoTicket
                titulo="Telefono"
                descripcion={
                  contacto?.contacto?.telefono || contacto?.telefono || "-"
                }
              />
              <TextInfoTicket
                titulo="Telefono2"
                descripcion={
                  contacto?.contacto?.telefono2 || contacto?.telefono2 || "-"
                }
              />
              <TextInfoTicket
                titulo="Domicilio de facturacion"
                descripcion={
                  contacto?.ubicacion?.direccion || contacto?.direcFac || "-"
                }
              />
              {contacto?.ubicacion?.latitud &&
                contacto?.ubicacion?.longitud && (
                  <TextInfoTicket
                    titulo="Coordenadas"
                    descripcion={`${contacto?.ubicacion?.latitud},${contacto?.ubicacion?.longitud}`}
                  />
                )}
              {contacto?.latitud && contacto?.longitud && (
                <TextInfoTicket
                  titulo="Coordenadas"
                  descripcion={`${contacto?.latitud},${contacto?.longitud}`}
                />
              )}
              <Divider
                sx={{
                  background: isDarkMode
                    ? "#3d4a62 !important"
                    : "#8993a4 !important",
                  marginBottom: 1,
                  width: "100%",
                }}
              />
              {(permisos["saldo_pendiente_servicio"] ||
                permisos["saldo_pendiente_servicio_all"] ||
                permisos["saldo_pendiente_servicio_pyme"] ||
                permisos["saldo_pendiente_servicio_corpo"]) && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mb: 1,
                    flexDirection: "column",
                  }}
                >
                  <ButtonBasic
                    textButton="Saldo Pendiente"
                    iconStart={<PaidOutlinedIcon />}
                    variant="wk"
                    color="nextWhite"
                    sx={{ border: 1 }}
                    onClick={() => onConsultarSaldo()}
                  />
                </Box>
              )}
            </Card>
          )}
        </Grid>
        <Grid item xs={12} md={9}>
          {isLoading ? (
            <CuentaTabsSkeleton isDarkMode={isDarkMode} />
          ) : (
            <Card
              sx={{
                background: isDarkMode
                  ? "#2d3a52 !important"
                  : "#fff !important",
                p: 2,
                borderRadius: 4,
              }}
            >
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: isDarkMode ? "#3d4a62" : "#6b788e",
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  variant="scrollable"
                  sx={{
                    "& .MuiTabs-indicator": {
                      background: isDarkMode ? "#90caf9" : "#0364ff",
                    },
                    "& .MuiButtonBase-root": {
                      color: isDarkMode ? "#b0bec5" : "#6b788e",
                      fontWeight: "bold",
                    },
                    "& .MuiButtonBase-root.Mui-selected": {
                      color: isDarkMode ? "#90caf9" : "#0364ff",
                    },
                  }}
                >
                  <Tab
                    label="Tickets"
                    {...a11yProps(0)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                  />
                  <Tab
                    label="Consultas"
                    {...a11yProps(1)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                  />
                  <Tab
                    label="Pre-Servicios"
                    {...a11yProps(2)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                  />
                  <Tab
                    label="Servicios"
                    {...a11yProps(3)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                  />
                  <Tab
                    label="Datos"
                    {...a11yProps(4)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                  />
                  <Tab
                    label="Historico"
                    {...a11yProps(5)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                  />
                  <Tab
                    label="Documentación"
                    {...a11yProps(6)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                  />
                  <Tab
                    label="Tareas"
                    {...a11yProps(7)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                  />
                  <Tab
                    label="Ordenes de Trabajo"
                    {...a11yProps(8)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                  />
                  <Tab
                    label="Recordatorios"
                    {...a11yProps(9)}
                    sx={{ minWidth: "fit-content", flex: 1 }}
                  />
                </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <TabCuentaTicket
                  cuenta={id}
                  nombreCompleto={contacto?.nombre_completo}
                  onGuardar={onGuardar}
                  mostrarFiltroServicio
                />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <TabCuentaConsultas
                  consultas={consultas}
                  actualizar={actualizarConsultas}
                  actualizarRecordatorios={actualizarRecordatorios}
                />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <TabCuentaPreServicio
                  preServicios={
                    contacto?.precontrato || contacto?.preServicios || []
                  }
                  cuenta={id}
                  datosOK={true}
                  contacto={contacto}
                  onGuardar={onGuardar}
                />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <TabCuentaServicio
                  tratos={contacto?.contratos || contacto?.servicios || []}
                />
              </TabPanel>
              <TabPanel value={value} index={4}>
                <TabCuentaEditar contacto={contacto} onGuardar={onGuardar} />
              </TabPanel>
              <TabPanel value={value} index={5}>
                <TabCuentaHistorico
                  historico={logs}
                  infoCliente={{ cuentaId: id, type: "nubicom" }}
                  onGuardar={actualizarHistorico}
                />
              </TabPanel>
              <TabPanel value={value} index={6}>
                <TabCuentaDocumentacion
                  infoIni={contactoImg}
                  filesAdj={filesAdj}
                  token={token}
                  onGuardar={onGuardar}
                  consulta={{ cuenta: id }}
                />
              </TabPanel>
              <TabPanel value={value} index={7}>
                <TabCuentaTareas
                  tareas={tareas}
                  traerTareas={actualizarTareas}
                />
              </TabPanel>
              <TabPanel value={value} index={8}>
                <CardOTZTask otsServicio={otsServicio} />
              </TabPanel>
              <TabPanel value={value} index={9}>
                <TabCuentaRecodatorios
                  recordatoriosAll={recordatorios}
                  cuenta={contacto?.cuenta}
                  nombreCompleto={contacto?.cliente}
                  onGuardar={actualizarRecordatorios}
                />
              </TabPanel>
            </Card>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
const mapStateToProps = (state) => ({
  contacto: state.contactos.current,
});

const mapDispatchToProps = (dispatch) => ({
  iniciarContacto: (data) => dispatch(ContactosAction.iniciarContacto(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CuentaFindByIdScreen);
